import React, { useState, useRef } from 'react';

const RejectionModal = ({ isOpen,title, onConfirm,onCancel,textField }) => {


  return (
    <>
      {/* Rollback Modal */}
      {isOpen && (
        <div className="modal-overlay popup-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center" style={{ zIndex: 9999 }}>
          <div className="modal-container  bg-white p-6 rounded-lg shadow-lg" style={{width:"40rem"}}>
            <div className="flex justify-between border-b pb-4">
              <h2 className="modal-heading popup-heading-text">{title}!</h2>
              <div className="text-xl cursor-pointer" onClick={onCancel}>X</div>
            </div>
                  <div className="mt-4">
                    <div className="mb-4">
                      <label className="text-left label-text-font">Reason<span style={{ color: '#F04438' }}>*</span></label>
                     {textField}
                    </div>

                    <div className="modal-actions flex justify-start gap-4">
                      <button type="button" className="custom-button popup-button" onClick={onCancel}>Cancel</button>
                      <button type="button" className="custom-button main-theme save-btn" onClick={onConfirm}>Save</button>
                    </div>
                  </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RejectionModal;
